function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { RudderAnalytics } from '@rudderstack/analytics-js';
import featureEnabled from 'shared/helper/feature';
import hasStatisticsConsent from 'rubriq/helpers/cookieConsent';
var rudderanalytics = null;
var initialized = false;
var WRITE_KEY = null;
var DATA_PLANE_URL = null;
var initAnalytics = function initAnalytics(writeKey, dataPlaneUrl) {
  if (!featureEnabled('rubriq_rudderstack')) return;
  if (initialized) return;
  if (!writeKey || !dataPlaneUrl) return;
  WRITE_KEY = writeKey;
  DATA_PLANE_URL = dataPlaneUrl;
  rudderanalytics = new RudderAnalytics();
  rudderanalytics.load(WRITE_KEY, DATA_PLANE_URL, {
    logLevel: process.env.NODE_ENV !== 'production' ? 'DEBUG' : 'ERROR'
  });
  rudderanalytics.ready(function () {
    rudderanalytics.page();
  });
  initialized = true;
};
export var trackEventRudder = function trackEventRudder(eventName) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!featureEnabled('rubriq_rudderstack')) return;
  if (!initialized || !rudderanalytics) return;
  rudderanalytics.track(eventName, properties);
};
export var trackNavbarEventRudder = function trackNavbarEventRudder(label, section) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!featureEnabled('rubriq_rudderstack')) return;
  if (!initialized || !rudderanalytics) return;
  rudderanalytics.track('Navbar Clicked', _objectSpread({
    label: label,
    section: section,
    page: window.location.pathname,
    device: navigator.userAgent
  }, extra));
};
export var identifyUserRudder = function identifyUserRudder(userId) {
  var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!featureEnabled('rubriq_rudderstack')) return;
  if (!initialized || !rudderanalytics) return;
  rudderanalytics.identify(userId, traits);
};
export var resetRudder = function resetRudder() {
  if (!featureEnabled('rubriq_rudderstack')) return;
  if (!initialized || !rudderanalytics) return;
  rudderanalytics.reset();
  initialized = false;
};
export default initAnalytics;